"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var SurfaceActionsShared_1 = require("./SurfaceActionsShared");
var store_1 = require("../store/store");
var owa_addins_core_1 = require("owa-addins-core");
var owa_mail_feature_flags_1 = require("owa-mail-feature-flags");
var owa_options_core_1 = require("owa-options-core");
var React = require("react");
var react_1 = require("satcheljs/lib/legacy/react");
var owa_outlook_service_options_1 = require("owa-outlook-service-options");
var owa_surface_actions_1 = require("owa-surface-actions");
var ABSTRACT_COMPOSE_SVG = require('./svg/abstractCompose.svg');
var ABSTRACT_ITEM_PART_SVG = require('./svg/abstractItemPart.svg');
var styles = require('./SurfaceActions.scss');
var SurfaceActionsFull = /** @class */ (function (_super) {
    tslib_1.__extends(SurfaceActionsFull, _super);
    function SurfaceActionsFull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SurfaceActionsFull.prototype.render = function () {
        var _a = this.props, isCompose = _a.isCompose, optionStore = _a.optionStore, userOptions = _a.userOptions;
        var actions = [];
        var addins = [];
        var selectedActions = [];
        var selectedAddins = [];
        var actionsOptionName;
        var addinsOptionName;
        var actionDisplayNameGetter;
        var actionIconNameGetter;
        var previewImageUri;
        var previewClassName;
        var extMode;
        if (isCompose) {
            actions = owa_surface_actions_1.getComposeStaticActions();
            extMode = owa_addins_core_1.ExtensibilityModeEnum.MessageCompose;
            // Get action/addin arrays and slice them to create a copy so we don't modify the real data.
            selectedActions = owa_options_core_1.getFallbackValueIfNull(optionStore.composeSurfaceActions, userOptions.composeSurfaceActions).slice();
            selectedAddins = owa_options_core_1.getFallbackValueIfNull(optionStore.composeSurfaceAddins, userOptions.composeSurfaceAddins).slice();
            actionsOptionName = 'composeSurfaceActions';
            addinsOptionName = 'composeSurfaceAddins';
            actionDisplayNameGetter = owa_surface_actions_1.getComposeActionDisplayName;
            actionIconNameGetter = owa_surface_actions_1.getComposeActionIconName;
            previewImageUri = ABSTRACT_COMPOSE_SVG;
            previewClassName = styles.composePreview;
        }
        else {
            actions = owa_surface_actions_1.getReadStaticActions();
            extMode = owa_addins_core_1.ExtensibilityModeEnum.MessageRead;
            // Get action/addin arrays and slice them to create a copy so we don't modify the real data.
            selectedActions = owa_options_core_1.getFallbackValueIfNull(optionStore.readSurfaceActions, userOptions.readSurfaceActions).slice();
            selectedAddins = owa_options_core_1.getFallbackValueIfNull(optionStore.readSurfaceAddins, userOptions.readSurfaceAddins).slice();
            actionsOptionName = 'readSurfaceActions';
            addinsOptionName = 'readSurfaceAddins';
            actionDisplayNameGetter = owa_surface_actions_1.getReadActionDisplayName;
            actionIconNameGetter = owa_surface_actions_1.getReadActionIconName;
            previewImageUri = ABSTRACT_ITEM_PART_SVG;
            previewClassName = styles.readingPanePreview;
        }
        if (owa_mail_feature_flags_1.isMailFeatureEnabled('rp-addins')) {
            var addinCollection = owa_surface_actions_1.getAddinCollection(extMode);
            addins = addinCollection ? addinCollection.sectionProps.items : [];
        }
        return (React.createElement("div", null,
            React.createElement(SurfaceActionsShared_1.default, { actions: actions, addins: addins, selectedActions: selectedActions, selectedAddins: selectedAddins, actionsOptionName: actionsOptionName, addinsOptionName: addinsOptionName, getDisplayNameFromAction: actionDisplayNameGetter, getIconNameFromAction: actionIconNameGetter, isLeftToRight: isCompose, previewImageUri: previewImageUri, previewClassName: previewClassName })));
    };
    SurfaceActionsFull = tslib_1.__decorate([
        react_1.reactive({
            optionStore: function () { return store_1.default; },
            userOptions: function () {
                return owa_outlook_service_options_1.getOptionsForFeature(owa_outlook_service_options_1.OwsOptionsFeatureType.SurfaceActions);
            },
        })
    ], SurfaceActionsFull);
    return SurfaceActionsFull;
}(React.Component));
exports.default = SurfaceActionsFull;
//# sourceMappingURL=SurfaceActionsFull.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-surface-actions-option/lib/components/SurfaceActionsFull.js
// module id = 3761
// module chunks = 2